import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import * as FileSaver from 'file-saver';
@Component({
  selector: 'app-incubatee-list',
  templateUrl: './incubatee-list.component.html',
  styleUrls: ['./incubatee-list.component.css'],
})
export class IncubateeListComponent implements OnInit {
  displayedColumns: string[] = [
    'index',
    'incubateeName',
    'email',
    'phone',
    'founderName',
    'registeredDate',
    'action',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  private listApi = environment.url + environment.incubateeList;
  private excelDownload = environment.url + environment.incubateeDownload;
  /**
   * Constructs a new instance of the IncubateeListComponent
   * @param router Service for navigation
   * @param makeapi Service for API requests
   * @param getdata Service for managing values
   * @param dialog Service for managing dialogs
   */
  constructor(
    private router: Router, // Used for navigating between routes
    private makeapi: ApiService, // Used for making API calls
    private getdata: ValueService, // Used for managing shared data
    public dialog: MatDialog // Used for opening dialogs
  ) {
    // Initialize the data source for the table
    this.dataSource = new MatTableDataSource();
  }

  roleValue;
  /**
   * Initializes the component by setting the role value and fetching the incubatee list.
   */
  ngOnInit(): void {
    // Retrieve the user's role from session storage
    this.roleValue = sessionStorage.getItem('role');

    // Fetch the list of incubatees
    this.incubateeList();
  }

  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSize: number = 10;
  pageNumber: number = 1;
  noData = true;
  /**
   * Fetches the list of incubatees and populates the table with the data
   */
  incubateeList() {
    // Create a request object to fetch the list of incubatees
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
    };
    // Call the API to fetch the list of incubatees
    this.ListApi();
  }
  /**
   * Fetches the list of incubatees and populates the table with the data.
   * Subscribes to the API response and updates the component data.
   */
  ListApi() {
    return this.makeapi
      .method(this.listApi, this.list, 'post')
      .subscribe((data: any) => {
        // If there is no data, set the noData flag to true
        if (data.count == 0) {
          this.noData = true;
        }
        // If there is data, set the noData flag to false and update the component data
        else {
          this.noData = false;
          // Set the total count of incubatees
          this.pageTotalCount = data.count;
          // Set the list of incubatees to be displayed
          this.disList = data.responsemodelList;
          // Set the MatTableDataSource with the list of incubatees
          this.dataSource = new MatTableDataSource(data.responsemodelList);
        }
      });
  }
  /**
   * Lifecycle hook that is called after the component's view has been fully initialized.
   * Called after the component's view has been fully initialized. Sets the paginator for the MatTableDataSource.
   */
  ngAfterViewInit() {
    // Set the paginator for the MatTableDataSource
    this.dataSource.paginator = this.paginator;
  }
  /**
   * Applies a filter to the MatTableDataSource.
   * Called when the user enters text into the filter input.
   * @param event The event containing the filter value
   */
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    // Trim the filter value to remove any leading or trailing whitespace
    // and convert it to lowercase so that the filter is case-insensitive
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  /**
   * Handles the pagination event
   * Updates the page number and page size based on the user's input
   * @param event - The pagination event containing the page index and page size
   */
  getServerData(event) {
    // Update the page number and page size
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;

    // Create the request parameters for the API call
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
    };

    // Call the API to fetch the updated data
    this.ListApi();
  }
  /**
   * Navigates to the route for adding a new incubatee or editing an existing incubatee
   * @param value The type of action to perform ('add' or 'edit')
   */
  eventAddBtn(value: string) {
    this.router.navigate(['admin', 'incubatee', value]);
  }
  /**
   * Edits an existing incubatee
   * @param value The type of action to perform ('edit')
   * @param id The ID of the incubatee to edit
   */
  editIncubatee(value: string, id: string) {
    /**
     * Set the incubatee ID in the shared service
     * @param id The ID of the incubatee to edit
     * @param value The type of action to perform ('edit')
     */
    this.getdata.incubeeId(btoa(id), value);
  }
  /**
   * Downloads the incubatee list as an Excel file.
   * Shows a loading indicator during the request and hides it once the file is downloaded.
   * The file is saved with a name based on the current date and time.
   */
  downloadExcel() {
    // Show loading indicator
    this.getdata.amizhthLoader('show');

    // Make API call to download the Excel file
    this.makeapi
      .method(
        this.excelDownload + sessionStorage.getItem('userId'), // Excel download URL with user ID
        '',
        'download'
      )
      .subscribe((data) => {
        // Hide loading indicator
        this.getdata.amizhthLoader('hide');

        // Generate the current date and time for the filename
        const date = new Date();
        let currentDate = `${date.getFullYear()}-${
          date.getMonth() + 1
        }-${date.getDate()}-${date.getSeconds()}`;

        // Define the filename with the current date and time
        let filename = 'StartupTN_Incubatees_' + currentDate + '.xlsx';

        // Save the downloaded file using FileSaver
        FileSaver.saveAs(data, filename);
      });
  }
}
